import { useState, useCallback } from 'react'
import { usePendenciasSocket } from '../../hooks/usePendenciasSocket'
import { PendenciaDto } from '../../dominios/pendencias/tipos/pendencia'
import { ToastPendencia } from './ToastPendencia'
import { useUsuario } from '../../contexts/UsuarioContext'

export function PendenciaListener() {
  const [pendenciaRecebida, setPendenciaRecebida] = useState<PendenciaDto | null>(null)
  const { usuario } = useUsuario()

  const handlePendenciaRecebida = useCallback((pendencia: PendenciaDto) => {
    // Só mostrar toast se a pendência for para o usuário atual e não estiver lida
    if (pendencia.usuarioDestinoId === usuario?.id && !pendencia.lida) {
      setPendenciaRecebida(pendencia)
    }
  }, [usuario?.id])

  usePendenciasSocket({
    onPendenciaRecebida: handlePendenciaRecebida,
    onPendenciaAtualizada: () => {
      // Não precisa fazer nada na atualização
    }
  })

  if (!pendenciaRecebida) return null

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <ToastPendencia
        pendencia={pendenciaRecebida}
        onClose={() => setPendenciaRecebida(null)}
      />
    </div>
  )
}

